import React from "react";
import { Link } from "react-router-dom";

const FooterItem = ({ itemImage, itemDescription, href }) => {
  return (
    <Link
      to={href}
      className="flex items-center pl-3 py-2 rounded-lg gap-2 hover:bg-lightBlue dark:hover:bg-navyAccent"
    >
      <div className="w-5 h-5 flex justify-center items-center">
        {itemImage}
      </div>
      <p className="text-black font-medium text-sm leading-[21px] dark:text-white">
        {itemDescription}
      </p>
    </Link>
  );
};

export default FooterItem;
